import { Workflow } from "../types/types"
import { genericRequest, workflowsRoute, workflowGroupRoute } from "./service"

/**
 * Gets list of all stored workflows.
 * 
 * @returns Gets all workflows
 */
export const getWorkflows = async (limit?: number, offset?: number): Promise<Workflow[] | Error> => {
  const query = {
    limit: `${limit ?? 0}`,
    skip: `${offset ?? 0}`,
  };
  return await genericRequest({ url: `${workflowsRoute}/`, method: "GET", query: query })
}

/**
 * Gets a workflow with a specified id.
 * 
 * @param id of workflow to fetch
 * 
 * @returns workflow for a given id
 */
export const getWorkflow = async (id: number): Promise<Workflow | Error> => {
  return await genericRequest({ url: `${workflowsRoute}/${id}`, method: "GET" })
}

/**
 * Uploads a workflow to the database.
 * 
 * @param workflow to upload
 * 
 * @returns created workflow
 */
export const addWorkflow = async (workflow: Workflow): Promise<Workflow | Error> => {
  const body = JSON.stringify(workflow)
  return await genericRequest({ url: `${workflowsRoute}/`, method: "POST", body: body })
}

/**
 * Deletes a workflow from the database.
 * 
 * @param workflowId of workflow to delete
 * 
 * @returns null when workflow deleted
 */
export const deleteWorkflow = async (workflowId: number) => {
  return await genericRequest({ url: `${workflowsRoute}/${workflowId}`, method: "DELETE" })
}

/**
 * Gets all workflows for a given group.
 * 
 * @param groupId id of the group to fetch workflows from
 * 
 * @returns list of all workflows belonging to the specified group
 */
export const getWorkflowsForGroup = async (groupId: number): Promise<Workflow[] | Error> => {
  return await genericRequest({ url: `${workflowsRoute}/group/${groupId}`, method: "GET" })
}

/**
 * Deletes a workflow group.
 * 
 * @param workflowId of workflow to remove
 * @param groupId of group to remove workflow from
 * 
 * @returns null
 */
export const removeWorkflowFromGroup = async (workflowId: number, groupId: number) => {
  return await genericRequest({ url: `${workflowGroupRoute}/${workflowId}/${groupId}`, method: "DELETE" })
}
